import { useEffect } from 'react'

// from https://stackoverflow.com/questions/32553158/detect-click-outside-react-component

type useClickOutside = (
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
) => void

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useClickOutside: useClickOutside = (ref, callback) => {
  useEffect(() => {
    /**
     * Execute callback if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback()
      }
    }

    // Bind the event listener
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback])
}

export default useClickOutside
